import * as React from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { EyeIcon, EyeSlashIcon } from "@phosphor-icons/react";

// Password field with a reveal toggle. Wraps <Input> so every call site keeps
// the same props it had as a plain type="password" input; `type` is owned here.
const PasswordInput = React.forwardRef(({ className, ...props }, ref) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        // room for the button so a long value doesn't run underneath it
        className={cn("pr-10", className)}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        // tabIndex -1 keeps Tab going straight from the field to submit
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-visibility-toggle"}
        className="absolute right-0 top-0 h-full px-3 flex items-center text-[#64748B] hover:text-[#0F172A] transition-colors disabled:opacity-50"
        disabled={props.disabled}
      >
        {visible ? <EyeSlashIcon size={18} /> : <EyeIcon size={18} />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
